module.exports = __webpack_public_path__ + "9fe4cb535e53b2bddff5a25377b485da.png";